import React from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { emtContentDataModel } from '../dataModels';
import { PAGE_NAMES } from '../../constants';
import RentalCompactGrid from './RentalCompactGrid';

const ToolRentalsCards = ({ contentId }) => {
  const { data, loading, error } = useDataModel('emtContent', {
    variables: { contentId, pageName: PAGE_NAMES.RENTALS },
    skip: !contentId,
  });
  const { title, rentalItems } = data?.emtContent?.content?.rentalsInformationv2?.toolRentals || {};
  return <RentalCompactGrid title={title} rentalItems={rentalItems} loading={loading} error={error} />;
};

ToolRentalsCards.displayName = 'ToolRentalsCards';
ToolRentalsCards.propTypes = { contentId: PropTypes.string.isRequired };
ToolRentalsCards.dataModel = emtContentDataModel;

export default ToolRentalsCards;